const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.oceanagold.forwoodsafety.com',
    USER_TOKEN_URL: 'https://hjfncphl83.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://ba7npmduef.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.oceanagold.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.oceanagold.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://rtlm1yf763.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
